export default __webpack_public_path__ + "static/media/apstore-full.fab60996.svg";